import Icon from "@mui/material/Icon";
import { styled, useTheme } from "@mui/material/styles";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import { ListItemButton } from "@mui/material";
import { useState } from "react";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import ExportContent from "./ExportContent";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    position: "fixed",
    width: 380,
    maxWidth: "90vw",
    backgroundColor: theme.palette.background.paper,
    top: 0,
    height: "100%",
    minHeight: "100%",
    bottom: 0,
    right: 0,
    margin: 0,
    zIndex: 1000,
    borderRadius: 0,
  },
}));

function AuraExport(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedExportType, setSelectedExportType] = useState(false);

  /**
   * Export Icon click
   */
  const handleIconClick = (event) => {
    // Show popover when icon is clicked
    setAnchorEl(event.currentTarget);
  };

  /**
   * Export Icon Close
   */
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  /**
   * Handle export list item selection (Export All/Custom Export)
   * It opens the Export dialog
   */
  const handleExportTypeSelection = (typeName) => {
    handlePopoverClose();
    setSelectedExportType(typeName);
  };

  /**
   * Close Export dialog
   */
  function handleClose(event, reason) {
    if (reason === "backdropClick") {
      // Prevent closing when clicking outside the dialog
      return;
    }
    // Close the dialog for other reasons (like pressing ESC or clicking a close button)
    setSelectedExportType(false);
  }

  /**
   * Export dialog submit
   */
  function handleSubmit(data) {
    setSelectedExportType(false);
  }

  const openPopover = Boolean(anchorEl);

  return (
    <>
      <>
        <Tooltip title={props.title}>
          <IconButton
            className="w-32 h-32 mx-4 p-0"
            component="span"
            size="large"
            onClick={handleIconClick}
          >
            <Icon fontSize="small">{props.icon || "save_alt"}</Icon>
          </IconButton>
        </Tooltip>
        <Popover
          open={openPopover}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <List>
            <ListItemButton
              onClick={() => handleExportTypeSelection("exportAll")}
            >
              <ListItemText primary="Export All" />
            </ListItemButton>
            <ListItemButton
              onClick={() => handleExportTypeSelection("customExport")}
            >
              <ListItemText
                className="capitalize"
                primary={`Custom ${props.stage} Export`}
              />
            </ListItemButton>
          </List>
        </Popover>
      </>
      {/* Export Dialog Section */}
      <StyledDialog
        aria-labelledby="settings-panel"
        aria-describedby="settings"
        open={
          selectedExportType === "exportAll" ||
          selectedExportType === "customExport"
        }
        onClose={handleClose}
        slotProps={{
          backdrop: { invisible: true },
        }}
        classes={{
          paper: "shadow-lg",
        }}
      >
        {/* Export Dialog content */}
        <ExportContent
          {...props}
          selectedExportType={selectedExportType}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
        />
      </StyledDialog>
    </>
  );
}

export default AuraExport;
